var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSonarqube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4464 63.4525H55.7612C55.7612 41.8358 37.924 24.2494 16 24.2494V21.5641C39.4052 21.5641 58.4464 40.3546 58.4464 63.4525Z",
    fill: "#549DD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3022 49.037C57.0783 35.4807 46.0916 24.1517 32.3196 20.1987L32.9367 18.0486C47.4727 22.2234 59.0753 34.1827 62.4789 48.5199L60.3022 49.037Z",
    fill: "#549DD0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.367 36.3087C59.0466 29.0678 53.3893 22.7549 46.4377 18.5306L47.3681 17C54.6223 21.4087 60.5266 28 64 35.5603L62.367 36.3087Z",
    fill: "#549DD0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonarqube);
export default __webpack_public_path__ + "static/media/sonarqube.64f13ecdaef94e1b43a9bbb6005c07df.svg";
export { ForwardRef as ReactComponent };